import React, { useState, useEffect, useRef } from 'react';
import getImageUrl from '../functions/getImageUrl';


const generateCSSTransform = () => {
    const maxZoom = 1.04;
    const plusOrMinus = Math.floor(Math.random()*2)*2-1; // will be either -1 or 1
    let panDistanceX = plusOrMinus * (maxZoom - 1) / 2; // fully to the left or right
    panDistanceX = Math.round(panDistanceX * 100); // because for css it needs to be a percent value
    return {
        transform: `translateX(${panDistanceX.toString()}%) scale(${maxZoom.toString()})`
    };
}


const KenBurnsImage = ({ children, isInHighlight, oddSlide, kenBurnsToggle, isJustOneItem, autoplaySpeed = 10000, backgroundImage, isMobile }) => {
    const [cssForKenBurns, setCSSForKenBurns] = useState({});
    const [fallbackInUse, setFallback] = useState(false)
    const divRef = useRef(null);
    const isInHighlightOrJustOne = isInHighlight || isJustOneItem;
    const cssTransition = { transitionDuration: autoplaySpeed + 'ms' };
    const cssNoTransition = { transitionDuration: '0ms' };
    
    useEffect(() => {
        if (kenBurnsToggle) { // start Ken-Burns-animation
            if (oddSlide)
                setCSSForKenBurns({ ...cssTransition }) // zoom out
            else
                setCSSForKenBurns({ ...generateCSSTransform(), ...cssTransition}); // zoom in
        }
        else { // reset Ken-Burns-animation to start position
            if (oddSlide)
                setCSSForKenBurns({ ...generateCSSTransform(), ...cssNoTransition }) // reset to zoomed in
            else
                setCSSForKenBurns({ ...cssNoTransition}); // reset to zoomed out
        }
    }, [kenBurnsToggle]);

    
    useEffect(() => {
        // when highlight becomes visible to a certain amount:
        const startHighlight = (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) setCSSForKenBurns({ ...generateCSSTransform(), ...cssTransition })
            });
        }
    
        // when highlight becomes invisible:
        const resetHighlight = (entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) setCSSForKenBurns({ ...cssNoTransition })
            });
        }
        
        const highlightStartObserver = new IntersectionObserver(startHighlight, { threshold: 0.33 });
        const highlightResetObserver = new IntersectionObserver(resetHighlight, { threshold: 0 });
        if (isInHighlightOrJustOne) {
            highlightStartObserver.observe(divRef.current);
            highlightResetObserver.observe(divRef.current);
        }
        return () => {
            highlightStartObserver.disconnect();
            highlightResetObserver.disconnect();
        };
    }, [isInHighlightOrJustOne]);

        
    const {finalImageURl, imageUrl, position} = getImageUrl(backgroundImage, isMobile, false, true)

    let styles = {    
        objectPosition: position
    }
    
    return(
        <div className='ken-burns-image-wrapper' ref={divRef}>
            {/* <div
                className={'ken-burns-image'}
                style={{
                    ...backgroundImage,
                    ...cssForKenBurns
                }}
            >
            </div> */}
            <img 
                src={finalImageURl} 
                className='ken-burns-image background-image'
                alt={'Background'} 
                style={{
                    ...styles,
                    ...cssForKenBurns
                }}
                onError={({ currentTarget }) => {
                    if(fallbackInUse) {
                        currentTarget.onerror = null; 
                        currentTarget.src = '';
                    } else {
                        setFallback(true)
                        currentTarget.onerror = null; 
                        currentTarget.src = imageUrl;
                    }
                }}
            />
            { children }
        </div>
    );   
}

export default KenBurnsImage;